import './App.css';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import WhoWeAre from './components/WhoWeAre';
import OurVision from './components/OurVision';
import WhatWeDo from './components/WhatWeDo';
import HowWeThink from './components/HowWeThink';
import Ventures from './components/Ventures';
import Founders from './components/Founders';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <HeroSection />
      <WhoWeAre />
      <OurVision />
      <WhatWeDo />
      <HowWeThink />
      <Ventures />
      <Founders />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
